<template>
<div :class="['error-misc-container', { active: this.isView }]" ref="errMiscModal">
  <h2>Oops!</h2>
  <h3>Something went wrong. <br />Please contact support.</h3>
  <BaseButton class="btn-email" @click="openEmail">Contact Support</BaseButton>
</div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    isView: {
      type: Boolean,
    },
  },
  computed: {},
  methods: {
    openEmail() {
      window.location.href = `mailto:team@menud.co`;
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.error-misc-container {
  align-items: center;
  background-color: white;
  bottom: 0;
  display: none;
  flex-direction: column;
  justify-content: center;
  left: 0;
  padding: 2rem;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 99999;

  &.active {
    display: flex;
  }

  h3 {
    margin-bottom: 2rem;
  }

  .btn-email {
    font-size: 1.6rem !important;
  }
}
</style>
